'use client'

import { api } from '@/api/v2/api'
import useAuth from '@/hooks/use-auth'
import { useQuery } from '@tanstack/react-query'

export default function useNotificationsCount() {
  const { isAuthenticated } = useAuth()

  const { data } = useQuery({
    queryKey: ['notifications-count'],
    queryFn: async (): Promise<{
      activity: number
      alert: number
    }> => {
      const { data } = await api.get(
        `/user/notifications/activity?cursor=0&limit=1&sortBy=date`
      )

      return {
        activity: data?.activityUnreadCount ?? 0,
        alert: data?.alertUnreadCount ?? 0,
      }
    },
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    enabled: isAuthenticated,
  })

  const activity = data?.activity ?? 0
  const alert = data?.alert ?? 0
  const total = activity + alert

  return {
    activity,
    alert,
    total,
  }
}
